import type { AnyAction, Dispatch } from 'redux';

import {
  setAnalyticsEnabled,
  setDebugModeEnabled,
  setLogLevel,
} from '../../reducers/UxReducers';

type LogLevel = 'debug' | 'info' | 'log';

/**
 * Initialize console commands namespace
 * Only initializes if actor is Cowbell user
 */
export function initializeConsoleCommands(
  dispatch: Dispatch<AnyAction>,
  isCowbell: boolean
): void {
  // Only initialize for Cowbell users
  if (!isCowbell) {
    return;
  }

  // Don't re-initialize if already set up
  if (window.moo) {
    return;
  }

  window.moo = {
    enableDebugMode: () => {
      dispatch(setDebugModeEnabled(true));
      // eslint-disable-next-line no-console
      console.log('🐄 Debug mode enabled');
    },

    enableAnalytics: () => {
      dispatch(setAnalyticsEnabled(true));
      // eslint-disable-next-line no-console
      console.log('🐄 Analytics enabled');
    },

    disableAnalytics: () => {
      dispatch(setAnalyticsEnabled(false));
      // eslint-disable-next-line no-console
      console.log('🐄 Analytics disabled');
    },

    disableDebugMode: () => {
      dispatch(setDebugModeEnabled(false));
      // eslint-disable-next-line no-console
      console.log('🐄 Debug mode disabled');
    },

    setLogLevel: (level: LogLevel) => {
      dispatch(setLogLevel(level));
      // Sync to window.moo for logger access
      window.moo.logLevel = level;
      // eslint-disable-next-line no-console
      console.log(`🐄 Log level set to: ${level}`);
    },
  };

  // eslint-disable-next-line no-console
  console.log(
    '🐄 Console commands initialized. Use window.moo to access commands.'
  );
}
